module.exports = __webpack_public_path__ + "static/media/key@about.4b1d6b07.png";